import { IGenericBet, ISingleBet } from '@bg-shared/business/Reports/interfaces_legacy/Bets';
import { GameId } from '@bg-shared/enums/GameId';
import { getBetType } from '@bg-shared/utils';
import { BetStatus } from '@bg-shared/enums/BetStatus';
import currency from 'currency.js';

export const recentBetsSelectors = {
    getBets: (count: number) => (state: IGenericBet[]) => state.slice(0, count),

    getActiveBetsGameIds: (state: IGenericBet[]): GameId[] =>
        (state.filter((bet) => bet.status === BetStatus.ACTIVE) as ISingleBet[]).map(
            (bet) => bet.gameId,
        ),

    getSingleActiveBets: (gameId: GameId, runId: number) => (state: IGenericBet[]) =>
        state.filter(
            (bet) =>
                ((getBetType.isSingle(bet) && bet.runId === runId) ||
                    (getBetType.isSubscription(bet) && bet.currentRunId === runId)) &&
                bet.gameId === gameId &&
                bet.status === BetStatus.ACTIVE,
        ),

    getBetsByBetId: (betIds: number[]) => (state: IGenericBet[]) =>
        state.filter((bet) => getBetType.isSingle(bet) && betIds.includes(bet.id)) as ISingleBet[],

    getActiveBetsByGameId: (gameId: GameId) => (state: IGenericBet[]) =>
        state.filter(
            (bet) =>
                getBetType.isSingle(bet) &&
                bet.gameId === gameId &&
                bet.status === BetStatus.ACTIVE,
        ) as ISingleBet[],

    getRunBetAmount:
        (runId: number) =>
        (state: IGenericBet[]): number =>
            state
                .filter((runBet) => (runBet as ISingleBet).runId === runId)
                .reduce((total, current) => currency(total).add(current.amountBet).value, 0),

    getRunWinAmount:
        (runId: number) =>
        (state: IGenericBet[]): number =>
            state
                .filter((runBet) => (runBet as ISingleBet).runId === runId)
                .reduce((total, current) => currency(total).add(current.amountWon || 0).value, 0),
};
